module.exports = __webpack_public_path__ + "img/4.fcffeeb3.png";